
    import Vue from 'vue'
    import { Component, Prop, Watch } from 'vue-property-decorator';
    import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
    import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
    import { Chip, FormFields, FilterFields, TableHeaderModel } from  '@/models/repsol-template.model';
    import { TableAgregadaHeaderModel  } from  '@/models/repsol-template-aggregate.model';
    import moment from 'moment';
    import ComponentBase from '@/mixins/componentBase';


    @Component({
        name: 'EjecucionesPage',
        components: {
            RepsolFilterBarComponent,
            RepsolFilterChipsComponent,
            RepsolTableComponent,
            RepsolFormPopupComponent
        },
    })

    class EjecucionesPage extends ComponentBase {

        @Prop()
        historico :boolean;
        @Watch('historico')
        cambioHistorico(){
            this.loadData();
        }

        isOpenFilters = false;
        isOpenForm = false;
        formIsValid = false;
        formOnlyRead = false;

        deleteFilter = "";

        popupHeaderText = "";

        filterChips:Chip[] = [];

        filterFields : FilterFields[] = [];


        formFields : FormFields[] = [];
        tableHeaders:TableHeaderModel[] = [];

        items:any[] = [];
        itemsAggregate: any[] = [];

        itemEdit:any = {};

        tableLoading = false;
        totalItems = 0;

        tableOptions = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [] as string[],
        sortDesc: [] as boolean[],
      };

        constructor() {
            super();
        }

        mounted(){
            this.getMaestroProducto();
            this.getMaestroCierreEstado();

            this.formFields  =  [
            {
                label: 'common.product',
                name: 'productoId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: true,
                items: this.maestroProductoEscritura,
                multiple: false,
                canView: true,
                cols: 12,
            },
            {
                label: 'ejecuciones.operations',
                name: 'operaciones',
                as: 'table',
                headers: [
                    { text: 'common.identifier', value: "identificador", sortable: true, as:'number' },
                    { text: 'common.desk', value: "mesa", sortable: true, as: 'multiselect', tooltip: true, //align: ' d-none',
                        items: [

                        ] },
                    { text: 'common.product', value: "producto", sortable: true, as: 'multiselect', items: [

                        ] },
                    { text: 'common.type', value: "tipo", sortable: true, as: 'multiselect',
                        items: [

                        ] },
                    { text: 'common.line', value: "linea", sortable: true, as: 'select',
                        items: [


                        ] },
                    { text: 'common.date', value: "fechaCreated", sortable: true, as: 'date' },
                    { text: 'common.strategy', value: "estrategia", sortable: true, as: 'multiselect' },
                    { text: 'ejecuciones.quantity', value: "cantidad", sortable: true, as: 'number' }
                ],
                model: '',
                isDisabled: false,
                isRequired: true,
                multiple: false,
                canView: false,
                cols: 12,
            }
        ];

         this.tableHeaders = [
            { text: 'common.identifier', value: "id", sortable: true, as:'number' },
            { text: 'common.product', value: "productId", sortable: true, as: 'select' , items: this.maestroProducto },
            { text: 'common.date', value: "creadoEn", sortable: true, as: 'date' },
            { text: 'ejecuciones.automatic', value: "automatico", sortable: true, as: 'select' ,
                items: this.maestroSiNo },
            { text: 'ejecuciones.state', value: "estadoId", sortable: true, as: 'multiselect',
                items: this.maestroCierreEstado },
            { text: 'common.error', value: "mensajeError", sortable: true, as: 'text' },
            { text: '', value: "actions", sortable: true, as:'', actions:[
                {icon: 'visibility', name: 'ver'},
                {icon: 'edit', name: 'editar'}
            ] },
        ];

        this.loadData();

        }

        onTableOptionsChanged(options: any) {
        this.tableOptions = { ...options };
        this.getEjecucionesList();
        }


        async getEjecucionesList(){
            this.openSpinner("ejecuciones.cargarListado");

            this.items = [];
            const filtro : any = {historico: this.historico};
            this.filterFields.forEach(f =>{
              if(f.model){
                  filtro[f.name] = f.model;
              }
          });

          const page = this.tableOptions?.page ?? 1;
            const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
            const sortBy = this.tableOptions?.sortBy ?? [];
            const sortDesc = this.tableOptions?.sortDesc ?? [];
            filtro.PageNumber = page || 1;
            filtro.PageSize = itemsPerPage || 10;

            if (sortBy && sortBy.length) {
                filtro.sortBy = sortBy[0];
                filtro.sortDesc = !!(sortDesc && sortDesc[0]);
            }
          const route = '/api/ejecucion/list';
          this.post({ apiUrl: route, entity: filtro })
          .then(data => {
                console.log(data.items);
                if (Array.isArray(data.items)) {
                    this.items = data.items;
                    this.totalItems = data.totalCount ?? 0;
            } else {
                    this.items = data?.items ?? [];
                    this.totalItems = data?.totalCount ?? 0;
                }
            })
            .catch(error =>{
                this.mostrarKO("ejecuciones.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        async exportarCierres() {

            const filtro: any = {
                historico: this.historico
            };

            this.filterFields.forEach(f => {
                if (f.model) {
                    filtro[f.name] = f.model;
                }
            });

            this.openSpinner("ejecuciones.cargarListado");

            this.post({
                apiUrl: '/api/ejecucion/Export',
                entity: filtro,
                array: true
            })
            .then(data => {

                const blob = new Blob(
                    [data],
                    {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute(
                    'download',
                    'Cierres.xlsx'
                );

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            })
            .catch(() => {
                this.mostrarKO("ejecuciones.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        loadData():void{
            this.filterFields.splice(0);
            this.filterFields.push(
            {
                    label: 'common.product',
                    name: 'productId',
                    as: 'selectlist',
                    model: [],
                    isDisabled: false,
                    isRequired: false,
                    items: this.maestroProductoEscritura,
                    multiple: true
                }
            );

            if(this.historico){
                var ayer = new Date();
                ayer.setDate(ayer.getDate() - 1);
                var hace1semana = new Date();
                hace1semana.setDate(hace1semana.getDate() - 8);

                this.filterFields.push(
                {
                    label: 'notificaciones.from_date',
                    name: 'desde',
                    as: 'date',
                    model: hace1semana.toISOString().split('T')[0],
                    isDisabled: false,
                    isRequired: false
                });
                this.filterFields.push(
                {
                    label: 'notificaciones.to_date',
                    name: 'hasta',
                    as: 'date',
                    model: ayer.toISOString().split('T')[0],
                    isDisabled: false,
                    isRequired: false
                });
            }

            this.changeFilters();

        }
        tableEventAction(action:string, item:any): void{
            switch (action) {
                case 'editar':
                    this.$router.push({ path: '/Cierres/Ejecuciones/Detalle/'+item.id});
                    break;
                case 'ver':
                    this.$router.push({ path: '/Cierres/Ejecuciones/ver/'+item.id});
                    break;
                default:
                    break;
            }
        }

        formEventAction(action:string, item:any): void{
            this.formFields[1].canView = false;

            switch (action) {
               case 'salvar':
                  if (item["$item_id"]) {
                       this.openSpinner("ejecuciones.actualizarElemento");
                      // Realizar la llamada a la API para actualizar el elemento
                      this.put({ apiUrl: `/api/ejecucion/${item["$item_id"]}`, entity: item })
                          .then(() => {
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("ejecuciones.actualizacionExitosa");
                              this.getEjecucionesList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                              this.mostrarKO("ejecuciones.errorActualizacion");
                              this.closeSpinner();
                          });
                  } else {
                      // Crear y listado
                      // Aquí realizamos la llamada a la API para crear un nuevo elemento
                      this.openSpinner("ejecuciones.crearElemento");
                      this.post({ apiUrl: '/api/ejecucion', entity: item })
                          .then(() => {
                              // Mostrar mensaje de éxito
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("ejecuciones.creacionExitosa");
                              this.getEjecucionesList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                              this.mostrarKO("ejecuciones.errorCreacion");
                              this.closeSpinner();
                          });
                  }
                  break;
                case 'cancelar':
                    this.isOpenForm = false;
                    break;

                case 'cambio':

                    break;
                default:
                    break;
            }
        }

         changeFilters(): void {
            this.filterChips.splice(0);
            this.filterFields.forEach(f =>{
                if(f.model){
                    if(Array.isArray(f.model)){
                        f.model.forEach(m =>{
                            this.filterChips.push({clave:`${f.name}-${m.id}`, valor:m.nombre, tooltip: f.label});
                        })
                    }
                    else
                    {
                        this.filterChips.push({clave:`${f.name}`, valor: f.model as string , tooltip: f.label});
                    }
                }
            });


            this.isOpenFilters = false;
            this.getEjecucionesList();
        }

        removeChip(clave: string): void {
            if(clave){
                this.filterChips = this.filterChips.filter(c => c.clave != clave);

                var name = clave.split('-')[0];
                var field = this.filterFields.find(f => f.name == name);
                if(field){
                    if(Array.isArray(field.model)){
                        var id = clave.split('-')[1];
                        field.model = field.model.filter(m => m.id != id);
                    }
                    else
                    {
                        field.model = '';
                    }
                }
                 this.getEjecucionesList();
            }
        }

        nuevoElemento() : void {
            this.popupHeaderText = "ejecuciones.nuevoElemento";
            this.itemEdit = {};
            this.isOpenForm = true;
        }

        rulesForm = {

        };
    }

    export default EjecucionesPage;
